import React from 'react';
import { useCategoryContext } from '../../../../contexts/categories/category.tsx';

const CategoryHeader = () => {
    const { category } = useCategoryContext()
    return (
        <h1>{category.name ?? "Create category"}</h1>
    );
};

export default CategoryHeader;
